import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ExternalLink } from 'lucide-react';

const PublicNav = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <nav className="fixed w-full z-50 glass" data-testid="public-nav">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold font-['Syne'] text-white" data-testid="nav-logo">
            DH <span className="text-indigo-500">Home Networking</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/services" className="text-slate-300 hover:text-white transition-colors" data-testid="nav-services">Services</Link>
            <Link to="/pricing" className="text-slate-300 hover:text-white transition-colors" data-testid="nav-pricing">Pricing</Link>
            <Link to="/portfolio" className="text-slate-300 hover:text-white transition-colors" data-testid="nav-portfolio">Portfolio</Link>
            <Link to="/contact" className="text-slate-300 hover:text-white transition-colors" data-testid="nav-contact">Contact</Link>
            <a 
              href="https://clients.dhhomenet.co.uk" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-300 hover:text-white transition-colors flex items-center space-x-1"
              data-testid="nav-client-portal"
            >
              <span>Client Portal</span>
              <ExternalLink size={14} />
            </a>
            <Link 
              to="/login" 
              className="bg-white text-black hover:bg-slate-200 font-semibold px-6 py-2 rounded-full transition-all duration-300 transform hover:scale-105"
              data-testid="nav-login-btn"
            >
              Login
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white"
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4" data-testid="mobile-menu">
            <Link to="/services" className="block text-slate-300 hover:text-white transition-colors" data-testid="mobile-nav-services">Services</Link>
            <Link to="/pricing" className="block text-slate-300 hover:text-white transition-colors" data-testid="mobile-nav-pricing">Pricing</Link>
            <Link to="/portfolio" className="block text-slate-300 hover:text-white transition-colors" data-testid="mobile-nav-portfolio">Portfolio</Link>
            <Link to="/contact" className="block text-slate-300 hover:text-white transition-colors" data-testid="mobile-nav-contact">Contact</Link>
            <a 
              href="https://clients.dhhomenet.co.uk" 
              target="_blank"
              rel="noopener noreferrer"
              className="block text-slate-300 hover:text-white transition-colors"
              data-testid="mobile-nav-client-portal"
            >
              Client Portal ↗
            </a>
            <Link 
              to="/login" 
              className="block bg-white text-black hover:bg-slate-200 font-semibold px-6 py-2 rounded-full text-center"
              data-testid="mobile-nav-login"
            >
              Login
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default PublicNav;
